export default {
    fields: [
        
        {
            key: "id",
            label: "#",
            sorter: false,
            active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "email",
            label: "email",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "phone",
            label: "phone",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "first_name",
            label: "first_name",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "last_name",
            label: "last_name",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "origin",
            label: "origin",
            sorter: true,
            active: true,
            filter: false,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "message",
            label: "message",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "status",
            label: "status",
            sorter: true,
            active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "created_on",
            label: "creation_date",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            _style: "width:15%",
        },

    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: {
        values: [5, 10, 20, 50, 100, 500, 1000, 5000, 10000],
    }
}